
import { Component, Vue } from 'vue-property-decorator'
import ConfirmDialog from "@/components/ConfirmDialog.vue"
import { State } from "vuex-class"
import User from "@/types/account/user"

@Component({
  components: {
    ConfirmDialog
  }
})

export default class ChangeMail extends Vue {
  private valid = false
  private loading = false
  private confirmDialog = false
  private newMail: string | null = null
  private currentMail: string | null = null
  private successMessageKey: string | null = null
  private emailRules = [
    (v: any) => !!v || this.$t('global.required'),
    (v: any) => /.+@.+/.test(v) || this.$t('account.mailNotValid')
  ]

  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;

  created () {
    this.currentMail = this.user.email
  }

  mailConfirmationRule () {
    return this.currentMail !== this.newMail || this.$t('settings.account.error.sameMail')
  }

  private changeMail () {
    this.loading = true
    this.$store.dispatch('account/changeMail', this.newMail)
      .then(() => {
        this.loading = false
        this.successMessageKey = 'settings.account.successfullyChangedMail'
        setTimeout(() => {
          this.successMessageKey = null
          this.$store.dispatch('account/logout')
        }, 3000)
      })
  }
}
